import { Colors } from 'basic-ui-lib/constants';
import styled from 'styled-components';
import { Box, Col } from '../Box';
import { Text } from '../Text';

export interface DashboardStatItemProps {
  label?: string;
  value?: string | number;
  icon?: React.ReactNode;
  backgroundColorIcon?: string;
}

const DashboardStatItem = ({ label, value, icon, backgroundColorIcon }: DashboardStatItemProps) => {
  return (
    <Container>
      <Col gap={0}>
        <Text body_1 medium color='neutral.text.3' left>
          {label}
        </Text>
        <Text title_h5 semibold color='neutral.text.5' left>
          {value}
        </Text>
      </Col>

      <Box
        display='flex'
        alignItems='center'
        padding={10}
        borderRadius={8}
        backgroundColor={backgroundColorIcon || Colors.primary[1]}
      >
        {icon}
      </Box>
    </Container>
  );
};

export default DashboardStatItem;

const Container = styled.div`
  display: flex;
  padding: 20px 24px;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid ${Colors.neutral.border[1]};
  background: ${Colors.neutral.bg[1]};
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 8px 16px;

    .title_h5 {
      font-size: 18px;
    }
  }

`;
